import { chatmonitoringConstants } from '../constants';
import { chatmonitoringService } from '../services';
import { showToast } from '../services/toast';

export const chatmonitoringActions = {
  fetchActiveClasses,
  getActiveClassStudents,
  updateStudentBlocks,
  fetchFlaggedMessages,
  fetchReportedMessages,
  updateAwardCoins,
  getChatUsername,
  updateChatUsername,
  fetchAppConfigs,
  hydrateMonitoringData,
  resetMonitoringData
};

function fetchActiveClasses() {
  return dispatch => {
    dispatch(request());

    return chatmonitoringService.getActiveClasses()
      .then(
        response => {
          dispatch(success(response.data));
          return response.data;
        },
        error => {
          dispatch(failure(error));
          // if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: chatmonitoringConstants.FETCH_ACTIVECLASSES_REQUEST } }
  function success(activeclasses) { return { type: chatmonitoringConstants.FETCH_ACTIVECLASSES_SUCCESS, activeclasses } }
  function failure(error) { return { type: chatmonitoringConstants.FETCH_ACTIVECLASSES_FAILURE, error } }
}

function getActiveClassStudents(classId) {
  return dispatch => {
    dispatch(request(classId));

    return chatmonitoringService.getActiveClassStudents(classId)
      .then(
        response => {
          dispatch(success(response.data, classId));
          return response.data;
        },
        error => {
          dispatch(failure(error, classId));
          // if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request(requestedClassId) { return { type: chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_REQUEST, classId: requestedClassId } }
  function success(activestudents, classId) { return { type: chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_SUCCESS, activestudents, classId } }
  function failure(error, classId) { return { type: chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_FAILURE, error, classId } }
}

function updateStudentBlocks(blockData) {
  return dispatch => {
    dispatch(request());

    chatmonitoringService.updateStudentBlocks(blockData)
      .then(
        response => {
          dispatch(success(blockData));
          showToast(response.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error)); 
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: chatmonitoringConstants.UPDATE_STUDENTBLOCKS_REQUEST } }
  function success(studentblocks) { return { type: chatmonitoringConstants.UPDATE_STUDENTBLOCKS_SUCCESS, studentblocks } }
  function failure(error) { return { type: chatmonitoringConstants.UPDATE_STUDENTBLOCKS_FAILURE, error } }

}


// function updateStudentBlocks(blockData) {
//   return dispatch => {

//     chatmonitoringService.updateStudentBlocks(blockData)
//       .then(
//         response => {

//           showToast(response.responseMessage, 'success');
//         },
//         error => {

//           if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
//         }
//       );
//   };
// }

function fetchFlaggedMessages(classId) {
  return dispatch => {
    dispatch(request(classId));

    return chatmonitoringService.fetchFlaggedMessages(classId)
      .then(
        response => {
          dispatch(success(response.data, classId));
          return response.data;
        },
        error => {
          dispatch(failure(error, classId));
          // if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request(requestedClassId) { return { type: chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_REQUEST, classId: requestedClassId } }
  function success(flaggedmessages, classId) { return { type: chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_SUCCESS, flaggedmessages, classId } }
  function failure(error, classId) { return { type: chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_FAILURE, error, classId } }
}

function fetchReportedMessages(classId) {
  return dispatch => {
    dispatch(request(classId));

    return chatmonitoringService.fetchReportedMessages(classId)
      .then(
        response => {
          dispatch(success(response.data, classId));
          return response.data;
        },
        error => {
          dispatch(failure(error, classId));
          //if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request(requestedClassId) { return { type: chatmonitoringConstants.FETCH_REPORTEDMESSAGES_REQUEST, classId: requestedClassId } }
  function success(reportedmessages, classId) { return { type: chatmonitoringConstants.FETCH_REPORTEDMESSAGES_SUCCESS, reportedmessages, classId } }
  function failure(error, classId) { return { type: chatmonitoringConstants.FETCH_REPORTEDMESSAGES_FAILURE, error, classId } }
}

function updateAwardCoins(awardDetails) {
  return dispatch => {
    dispatch(request());

    return chatmonitoringService.updateAwardCoins(awardDetails)
      .then(
        response => {
          dispatch(success(awardDetails));
          showToast(response.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: chatmonitoringConstants.UPDATE_AWARDCOINS_REQUEST } }
  function success(awardedcoins) { return { type: chatmonitoringConstants.UPDATE_AWARDCOINS_SUCCESS, awardedcoins } }
  function failure(error) { return { type: chatmonitoringConstants.UPDATE_AWARDCOINS_FAILURE, error } }

}


function getChatUsername(classid, adminid) {
  return dispatch => {
    dispatch(request(classid));

    return chatmonitoringService.getChatUsername(classid, adminid)
      .then(
        response => {
          dispatch(success(response, classid));
          return response;
        },
        error => {
          dispatch(failure(error, classid));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request(requestedClassId) { return { type: chatmonitoringConstants.FETCH_CHATUSERNAME_REQUEST, classId: requestedClassId } }
  function success(chatuser, classId) { return { type: chatmonitoringConstants.FETCH_CHATUSERNAME_SUCCESS, chatuser, classId } }
  function failure(error, classId) { return { type: chatmonitoringConstants.FETCH_CHATUSERNAME_FAILURE, error, classId } }

}

function updateChatUsername(chatuserDetails) {
  return dispatch => {
    dispatch(request());

    return chatmonitoringService.updateChatUsername(chatuserDetails)
      .then(
        response => {
          dispatch(success(chatuserDetails));
          showToast(response.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: chatmonitoringConstants.UPDATE_CHATUSERNAME_REQUEST } }
  function success(chatuser) { return { type: chatmonitoringConstants.UPDATE_CHATUSERNAME_SUCCESS, chatuser } }
  function failure(error) { return { type: chatmonitoringConstants.UPDATE_CHATUSERNAME_FAILURE, error } }

}

function fetchAppConfigs() {
  return dispatch => {
    dispatch(request());

    return chatmonitoringService.fetchAppConfigs()
      .then(
        response => {
          dispatch(success(response.data));
          return response.data;
        },
        error => {
          dispatch(failure(error));
          // if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: chatmonitoringConstants.FETCH_APPCONFIGS_REQUEST } }
  function success(appconfigs) { return { type: chatmonitoringConstants.FETCH_APPCONFIGS_SUCCESS, appconfigs } }
  function failure(error) { return { type: chatmonitoringConstants.FETCH_APPCONFIGS_FAILURE, error } }
}

function hydrateMonitoringData(payload) {
  return {
    type: chatmonitoringConstants.HYDRATE_CHATMONITORING_DATA,
    payload
  };
}

function resetMonitoringData() {
  return { type: chatmonitoringConstants.RESET_CHATMONITORING_DATA };
}
